/**
 * OutpostControlsPanel - UI for managing outposts on current tile
 *
 * Shows:
 * - Create Outpost button (if no outpost)
 * - Outpost info and management (if outpost exists)
 * - Construction progress bar (if building)
 * - Trade route status
 */

import React from 'react';

function OutpostControlsPanel({
  currentOutpost,
  nodeId,
  onCreateOutpost,
  onManageOutpost,
  getOutpostConstructionProgress,
  isTileOnTradeRoute,
  worldMap,
}) {
  // If there's an outpost, show its info
  if (currentOutpost) {
    const progress = currentOutpost.isConstructing
      ? getOutpostConstructionProgress(nodeId)
      : null;
    const outpostOnTradeRoute = nodeId ? isTileOnTradeRoute(nodeId) : false;
    const outpostHasRouteSegment = !!worldMap.tradeRoutes?.segments?.[nodeId]?.built;

    return (
      <div className="wm-outpost-info">
        <div className="wm-outpost-header">
          <span className="wm-outpost-label">🏰 Outpost</span>
          <span className="wm-outpost-name">{currentOutpost.name}</span>
        </div>
        {currentOutpost.isConstructing && progress ? (
          <div className="wm-outpost-construction">
            <div className="wm-outpost-progress-bar">
              <div
                className="wm-outpost-progress-fill"
                style={{ width: `${progress.percent}%` }}
              />
            </div>
            <div className="wm-outpost-timer">
              ⏱️ {progress.formattedRemaining} remaining
            </div>
          </div>
        ) : (
          <>
            {/* Trade Route Status */}
            <div className="wm-outpost-trade-route">
              <span className="wm-outpost-tr-label">🛤️ Trade Route:</span>
              {outpostOnTradeRoute ? (
                <span className="wm-tr-inline connected">✅ Connected</span>
              ) : outpostHasRouteSegment ? (
                <span className="wm-tr-inline partial">🔗 Not Connected</span>
              ) : (
                <span className="wm-tr-inline none">No Route</span>
              )}
            </div>
            <button
              className="wm-manage-outpost-btn"
              onClick={() => onManageOutpost(nodeId)}
            >
              ⚔️ Manage Outpost
            </button>
          </>
        )}
      </div>
    );
  }

  // No outpost - show create button
  return (
    <div className="wm-outpost-section">
      <button
        className="wm-create-outpost-btn"
        onClick={() => onCreateOutpost(nodeId)}
      >
        🏰 Create Outpost
      </button>
    </div>
  );
}

export default OutpostControlsPanel;
